var addClassId = function(){
  
  var c1 = document.getElementsByClassName('c1');
   $( c1 ).addClass('trackerClass');
   $( c1 ).attr('id', 'c1');
  var c2 = document.getElementsByClassName('c2');
   $( c2 ).addClass('trackerClass');
  var select = document.getElementsByClassName('ss-single-selected');
   $( select ).attr('id', 'select');
  
  //Attach event tracking
  
  $( '#c1' ).bind('click', function(){
    ga('send', 'event', 'button1', 'click', 'Book Appointment');
  });
  
  $( '#continue-button-2' ).bind('click', function(){
    ga('send', 'event', 'button2', 'click', 'Book Appointment');
  });
  
  $( '#select' ).bind('click', function(){
  	ga('send', 'event', 'select', 'click', 'Book Appointment');
    
     var antiAging = document.getElementsByClassName('ss-option')[1];
     $( antiAging ).attr('id', 'anti-aging');
     var skinCare = document.getElementsByClassName('ss-option')[2];
     $( skinCare ).attr('id', 'skin-care');
        $( '#anti-aging' ).bind('click', function(){
          ga('send', 'event', 'anti-aging', 'click', 'Book Appointment');});
        $( '#skin-care' ).bind('click', function(){
  		ga('send', 'event', 'skin-care', 'click', 'Book Appointment');});   
	});
};

setTimeout(addClassId, 2000);

